export const enviarDatosAlServidor = async (json, endpoint, accessToken) => {
    const baseUrl = process.env.REACT_APP_BASE_URL
    const consulta = `${baseUrl}/${endpoint}`
    //const consulta = `http://localhost:9000/${endpoint}`

    // http://localhost:5056/ServiceOperation/UpdateAdmin
    console.log(consulta);
    console.log(json);
    console.log(JSON.stringify(json));
    try {
        const respuesta = await fetch(consulta, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            headers: {Authorization: `Bearer ${accessToken}`, accept: '*/*', 'Content-Type': 'application/json' },

            body: JSON.stringify({ document: json }),
        });

        
        const resultado = await respuesta.json();
        
        console.log(resultado);


        if (respuesta.ok) {
            return {
                success: true,
                message: resultado.message,
                registrosDuplicados: resultado.registrosDuplicados,
                registrosExitosos: resultado.registrosExitosos,
                registrosProcesados: resultado.registrosProcesados,
                totalRegistros: resultado.totalRegistros
            }; // Asume que el servidor responde con un mensaje en caso de éxito
        } else {
            return { success: false, message: resultado.message, status: respuesta.status }; // Asume que el servidor responde con un mensaje de error
        }

        // Aquí puedes manejar la respuesta exitosa, por ejemplo, mostrando un mensaje al usuario
    } catch (error) {
        console.error('Error al enviar los datos:', error.message);
        if (error.response) {
            // El servidor respondió con un estado fuera del rango de 2xx
            console.error('Detalle del error:', {
                status: error.response.status,
                statusText: error.response.statusText,
                headers: error.response.headers,
                data: error.response.data
            });
        } else if (error.request) {
            // La solicitud fue hecha pero no se recibió respuesta
            console.error('La solicitud fue hecha pero no se recibió respuesta', error.request);
        } else {
            // Algo ocurrió al configurar la solicitud que disparó el error
            console.error('Error en la configuración de la solicitud:', error.message);
        }
        console.error('Configuración de la solicitud:', error.config);
    }
    
};